import React from "react";
import { AddMedicationForm } from "./AddMedicationForm";
import { DisContinuedMedication } from "./discontinuedMedication";

import { OrderPages } from "./order";
import { ActiveMedication } from "./activeMedication";
import { MedicationHistoryTable } from "./medicationHistoryTable";
import EditMedication from "./editMedication";
import { ActiveMedicineData, MedicationData } from "sharedTypes";
import { MedicationDetails } from "./medicationDetails";

interface SwitchCaseProps {
  medicationDetailsPage: OrderPages;
  onFormSubmit: (formData: MedicationData, isEdit?: boolean) => void;
  onMedicationDetailsPageChange: (page: OrderPages) => void;
  readonly isLoadingReasonsList: boolean;
  readonly selectedMedicationForHistory: ActiveMedicineData | null;
  readonly onSelectedMedicationforHistoryChange: (
    value: ActiveMedicineData | null
  ) => void;
  readonly searchValue: string;
  setSelectedReasons(reasons: string): void;
  readonly selectedReasons: string;
  readonly medicationAddedToggle: boolean;
  readonly onDiscontinueMedication: (
    patientId: string | number,
    medicineId: string,
    reasons: { id: number | string; reason: string }[]
  ) => void;
  readonly onDeleteMedication: (
    patientId: string | number,
    medicineId: string
  ) => void;
}

const SwitchMedicationComponent: React.FC<SwitchCaseProps> = ({
  medicationDetailsPage,
  onMedicationDetailsPageChange,
  onFormSubmit,
  selectedMedicationForHistory,
  onSelectedMedicationforHistoryChange,
  searchValue,
  setSelectedReasons,
  selectedReasons,
  medicationAddedToggle,
  onDiscontinueMedication,
  onDeleteMedication
}) => {
  switch (medicationDetailsPage) {
    case OrderPages.DiscontinuedMedication:
      return <DisContinuedMedication searchValue={searchValue} />;

    case OrderPages.AddMedicationForm:
      return (
        <AddMedicationForm
          onFormSubmit={onFormSubmit}
          onMedicationDetailsPageChange={onMedicationDetailsPageChange}
        />
      );

    case OrderPages.MedicationHistory:
      return (
        <MedicationHistoryTable
          selectedMedicationForHistory={selectedMedicationForHistory}
        />
      );

    case OrderPages.EditMedication:
      return (
        <EditMedication
          selectedMedication={selectedMedicationForHistory}
          onFormSubmit={onFormSubmit}
          onDiscontinueMedication={onDiscontinueMedication}
          onDeleteMedication={onDeleteMedication}
        />
      );
    case OrderPages.MedicineDetails:
      return (
        <MedicationDetails selectedMedication={selectedMedicationForHistory} />
      );
    default:
      return (
        <ActiveMedication
          onMedicationDetailsPageChange={onMedicationDetailsPageChange}
          onSelectedMedicationforHistoryChange={
            onSelectedMedicationforHistoryChange
          }
          searchValue={searchValue}
          setSelectedReasons={setSelectedReasons}
          selectedReasons={selectedReasons}
          medicationAddedToggle={medicationAddedToggle}
        />
      );
  }
};

export default SwitchMedicationComponent;
